import { api, API_BASE } from "@/lib/api";

const BASE = API_BASE;

/**
 * Streams a single-field AI edit. Calls onDelta with each token as it arrives
 * and resolves with the finished text.
 */
export async function streamAssist(payload, onDelta, signal) {
  const res = await fetch(`${BASE}/admin/ai/assist`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

  if (!res.ok) {
    let detail = "The AI assistant is unavailable right now.";
    try {
      const j = await res.json();
      if (j?.detail) detail = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
    } catch (_) {}
    throw new Error(detail);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let text = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";
    for (const line of lines) {
      if (!line.startsWith("data: ")) continue;
      const raw = line.slice(6);
      if (raw === "[DONE]") return text;
      let evt;
      try {
        evt = JSON.parse(raw);
      } catch (_) {
        continue;
      }
      if (evt.error) throw new Error(evt.error);
      if (evt.delta) {
        text += evt.delta;
        onDelta?.(text);
      }
    }
  }
  return text;
}

export async function draftRecord(payload) {
  const res = await api.post("/admin/ai/draft", payload);
  return res.data.draft;
}

/** Flattens a record into a short plain-text brief the model can read for grounding. */
export function recordContext(item, fields, skipKey) {
  if (!item) return "";
  return fields
    .filter((f) => f.key !== skipKey && ["text", "loc", "locarea", "textarea"].includes(f.type || "text"))
    .map((f) => {
      const v = item[f.key];
      const text = v && typeof v === "object" ? v.en || v.ar : v;
      if (!text || typeof text !== "string") return null;
      return `${f.label}: ${text.slice(0, 600)}`;
    })
    .filter(Boolean)
    .join("\n")
    .slice(0, 3000);
}
